module.exports = new __parcel__URL__("machines_pirate_nation_golden_galleon_level_1.d9aac132.png").toString();